export enum Role {
    GP = 'general_practitioner',
    SP = 'specialist',
    PM = 'practice_manager',
    PAT = 'patient',
    PCN = 'primary_care_nurse',
    SCN = 'secondary_care_nurse',
}